import graphql from "babel-plugin-relay/macro";
import { useSetAtom } from "jotai";

import { currentProfileAtom } from "@/features/Club/atoms";

import {
  WhooshMutationError,
  useMutationWithError,
} from "../../../utils/hooks/useMutationWithError";
import {
  UpdateMemberProfileInput,
  useUpdateMemberProfileMutation,
} from "./__generated__/useUpdateMemberProfileMutation.graphql";

export const useUpdateMemberProfile = (
  callback?: () => void,
  onError?: (errors: any) => void
) => {
  const setCurrentProfile = useSetAtom(currentProfileAtom);
  const [updateMemberProfile, isUpdating] =
    useMutationWithError<useUpdateMemberProfileMutation>(ProfileUpdateFormGql);

  const handleUpdateMemberProfile = (input: UpdateMemberProfileInput) => {
    updateMemberProfile({
      variables: { input },
      onCompleted: (response) => {
        const updatedMember = response.responsePayload?.member;

        if (updatedMember) {
          setCurrentProfile((currentProfile) => {
            if (currentProfile?.memberId !== updatedMember.id) {
              return currentProfile;
            }

            return {
              ...currentProfile,
              profileImagePublicId:
                updatedMember.profileImage?.publicId ?? undefined,
            };
          });
        }

        callback?.();
      },
      onCompletedErrorCustom: (errors: WhooshMutationError[]) => {
        onError?.(errors);
        return errors;
      },
    });
  };

  return [handleUpdateMemberProfile, isUpdating] as const;
};

export const ProfileUpdateFormGql = graphql`
  mutation useUpdateMemberProfileMutation($input: UpdateMemberProfileInput!) {
    responsePayload: updateMemberProfile(input: $input) {
      member {
        id
        firstName
        lastName
        profileImage {
          # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
          publicId: renderingKey
        }
        phoneNumber {
          nationalNumber
        }
        user {
          ...ClubSwitcherFragment_memberUser
          activeMemberProfiles: memberProfiles(active: true, hidden: false) {
            count
          }
          memberProfiles(active: true) {
            count
            edges {
              node {
                hidden
                id
                onboardedAt
              }
            }
          }
        }
      }
      success
      errors {
        code

        message
        field
      }
    }
  }
`;
